import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefRemediation from "table-defs/TableDefRemediation";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";

import {
    loadRemediationPlansAction,
    loadSitesAction,
    completeRemediationPlanAction,
    incompleteRemediationPlanAction,
    notifyRemediationPlanAction,
    deleteRemediationPlanAction,
} from "store/actions/Actions";

import useFilterRows from "helpers/customHooks/useFilterRows";
import { setSelectedRows, toggleDropdowns } from "helpers/utils";

const Remediation = props => {
    // const [state, setState] = useState({
    //     selectedRows: null,
    // });

    const {
        loadRemediationPlansAction,
        loadSitesAction,
        completeRemediationPlanAction,
        incompleteRemediationPlanAction,
        notifyRemediationPlanAction,
        deleteRemediationPlanAction,
        SitesReducer,
        RemediationReducer,
        // UserOrgSiteReducer,
    } = props;

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!RemediationReducer.remediation_plans && SitesReducer.sites) {
            loadRemediationPlansAction();
        }
    }, [RemediationReducer.remediation_plans, loadRemediationPlansAction, SitesReducer.sites]);

    // ##############################################

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        selected_sites: [],
    };

    const [filters, setFilters] = useState(noFilters);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const filteredRows = useFilterRows(filters, RemediationReducer.remediation_plans);

    // ##############################################

    // const onChangeRowSelect = ({ selectedRows }) => {
    //     if (selectedRows !== state.selectedRows) {
    //         setState({
    //             ...state,
    //             selectedRows
    //         });
    //     }
    // };

    const openAddNewIncident = () => props.history.push("/achieve/remediation/add");

    const statusDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();

    const [selectedRemeiationIds, setSelectedRemeiationIds] = useState([]);
    const selectedIds = selectedRemeiationIds.map(item => item.id);

    // const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) || false;
    // const is_officer = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) || false;
    // const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    return (
        <AppLayoutWrapFull onClick={toggleDropdowns([chooseActionDropdownRef, statusDropdownRef, siteDropdownRef])}>
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD PLAN"
                    primaryButtonHandler={openAddNewIncident}
                    searchHandler={e =>
                        setFilters({ ...filters, text: e.target.value || "" })
                    }
                    statusDropdownRef={statusDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    searchValue={filters.text}
                    chooseAction={
                        [
                            {
                                actionName: "Notify Selected",
                                actionHandler: () => {
                                    notifyRemediationPlanAction({ items: selectedIds });
                                }
                            },
                            {
                                actionName: "Mark Selected Complete",
                                actionHandler: () => {
                                    completeRemediationPlanAction({ items: selectedIds });
                                }
                            },
                            {
                                actionName: "Mark Selected Incomplete",
                                actionHandler: () => {
                                    incompleteRemediationPlanAction({ items: selectedIds });
                                }
                            },
                            {
                                actionName: "Delete Selected",
                                actionHandler: () => {
                                    
                                    const idCount = selectedIds.length;

                                    if (idCount > 0) {
                                        setShowConfirmModal({
                                            title: 'Delete selected remediations',
                                            question: idCount === 1 ? 
                                                `Are you sure you want to delete the selected remediation?` : 
                                                `Are you sure you want to delete ${idCount} selected remediations?`,
                                            confirmAction: () => {
                                                deleteRemediationPlanAction({ items: selectedIds });
                                            },
                                        });
                                    } else {
                                        setShowConfirmModal({
                                            type: 'simple',
                                            title: 'Nothing selected',
                                            question: `Please select remediations to be deleted.`,
                                        });
                                    }
                                }
                            }
                        ]
                    }
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: SitesReducer.sites ? SitesReducer.sites.map(site => {
                            return {
                                id: site.id,
                                siteName: site.name,
                                value: filters.selected_sites.includes(site.id) ? true : false
                            }
                        }) : [],
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["Pending", "Incomplete", "Complete"]
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {RemediationReducer.remediation_plans &&
                <FullDataTable
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains("col-row-selector")
                        ) {
                            return;
                        }
                        props.history.push(`/achieve/remediation/edit?id=${this.props.rowData.id}`);
                    }}
                    rowsData={filteredRows}
                    definitions={TableDefRemediation}
                    setSelectedRows={setSelectedRows(["id"], setSelectedRemeiationIds)}
                    customTableProps={
                        {
                            edit: ({ id }) => props.history.push(`/achieve/remediation/edit?id=${id}`),
                            complete: ({ id }) => {
                                completeRemediationPlanAction({ items: [id] });
                            },
                            incomplete: ({ id }) => {
                                incompleteRemediationPlanAction({ items: [id] });
                            },
                            notify: ({ id }) => {
                                notifyRemediationPlanAction({ items: [id] })
                            },
                            delete: ({ id, name }) => {
                                setShowConfirmModal({
                                    title: 'Delete the remediation',
                                    question: `Are you sure you want to remove the remediation "${name}"`,
                                    confirmAction: () => {
                                        deleteRemediationPlanAction({ items: [id] });
                                    },
                                });
                            }
                        }
                    }
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    RemediationReducer: state.RemediationReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadRemediationPlansAction,
    completeRemediationPlanAction,
    incompleteRemediationPlanAction,
    notifyRemediationPlanAction,
    deleteRemediationPlanAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Remediation);
